import {
  EllipsisWithTooltip,
  Stack,
  Typography,
  tokens,
} from '@cast/design-system';

type Props = {
  label: string;
  steps: ReadonlyArray<{
    readonly title: string;
    readonly description: string;
  }>;
};

export const OptimizeBannerSteps = ({ label, steps }: Props) => (
  <Stack
    flex="0 0 320px"
    gap={12}
    p={24}
    sx={{
      bgcolor: tokens.theme.bg.structural.surfaceRaised,
      borderLeft: '1px solid',
      borderColor: tokens.theme.border.structural.neutralSubtle,
    }}
  >
    <Typography
      variant="L12B"
      sx={{ color: tokens.theme.fg.structural.secondary }}
    >
      {label}
    </Typography>

    <Stack gap={0} flex={1} justifyContent="space-between">
      {steps.map((step) => (
        <Stack key={step.title} gap={0}>
          <Typography
            variant="P14M"
            sx={{ color: tokens.theme.fg.structural.primary }}
          >
            {step.title}
          </Typography>
          <EllipsisWithTooltip
            TypographyProps={{
              variant: 'P12R',
              sx: { color: tokens.theme.fg.structural.secondary },
            }}
          >
            {step.description}
          </EllipsisWithTooltip>
        </Stack>
      ))}
    </Stack>
  </Stack>
);
